import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

interface Props {
  children: ReactNode;
  keywords?: string;
}

export default function SiteLayout({ children }: Props) {
  return (
    <div className="min-h-screen flex flex-col site-shell">
      <SiteHeader />
      <main className="flex-1 w-full">{children}</main>
      <SiteFooter />
    </div>
  );
}